import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

// Map toast levels to icon classes
const iconMap = {
    success: 'pe-7s-check',
    warning: 'pe-7s-attention',
    error: 'pe-7s-close-circle',
    info: 'pe-7s-info'
};

// Map toast levels to CSS classes
const classMap = {
    success: 'toast-legacy toast-success',
    warning: 'toast-legacy toast-warning',
    error: 'toast-legacy toast-error',
    info: 'toast-legacy toast-info'
};

/**
 * Displays a toast notification with consistent styling and accessibility.
 * @param {Object} options
 * @param {'success'|'warning'|'error'|'info'} options.level - Toast type
 * @param {string} options.message - Message to display
 * @param {string} [options.toastId] - Optional ID to prevent duplicates
 * @param {string} [options.position] - Toast position (default: 'top-center')
 * @param {boolean} [options.inSupport] - Optional flag for support styling
 * @param {number} [options.autoClose=15000] - Optional duration in milliseconds before toast auto-dismisses.
 */
export const showToast = ({
                              level = 'info',
                              message,
                              toastId,
                              position = 'top-center',
                              inSupport = false,
                              autoClose = 15000
                          }) => {
    const baseClass = classMap[level] || 'toast-legacy toast-info';
    const finalClass = inSupport ? `${baseClass} support-toast` : baseClass;

    toast(message, {
        type: level,
        position,
        autoClose,
        icon: <span className={`toast-icon ${iconMap[level]}`} />,
        toastId: toastId || `${level}-${Date.now()}`,
        role: 'alert',
        ariaLabel: message,
        className: finalClass
    });
};